import {
  PaymentMethodRulesCreate,
  PaymentMethodRulesEdit,
  PaymentMethodRulesList
} from 'pages/payment_deals/payment_method_rules';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'offers/payment_method_rules',
  label: 'Regras de Parcelamento',
  list: PaymentMethodRulesList,
  edit: PaymentMethodRulesEdit,
  create: PaymentMethodRulesCreate,
  actions: ['list', 'show', 'create', 'edit'],
  parentName: 'payment_deals'
};

export default generateResources(resource);
